import { makeStyles } from '@fluentui/react'

export const usePageWrapperStyles = makeStyles(() => ({
  wrapper: {
    maxWidth: '1232px',
    width: '100%',
    margin: '24px auto',
  },
}))
